var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormGroup, FormControl } from "@angular/forms";
var SamplingReportFormGroup = /** @class */ (function (_super) {
    __extends(SamplingReportFormGroup, _super);
    function SamplingReportFormGroup() {
        return _super.call(this, {
            plantingDateRange: new FormControl(null),
            samplingDateRange: new FormControl(null),
            crop: new FormControl(),
            laboratory: new FormControl(),
            laboratoryAssay: new FormControl(),
            growthStage: new FormControl()
        }, {
            validators: SamplingReportFormGroup.SamplingReportFormGroupValidator
        }) || this;
    }
    Object.defineProperty(SamplingReportFormGroup.prototype, "plantingDateRangeFormControl", {
        get: function () {
            return this.get('plantingDateRange');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormGroup.prototype, "samplingDateRangeFormControl", {
        get: function () {
            return this.get('samplingDateRange');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormGroup.prototype, "cropFormControl", {
        get: function () {
            return this.get('crop');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormGroup.prototype, "laboratoryFormControl", {
        get: function () {
            return this.get('laboratory');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormGroup.prototype, "laboratoryAssayFormControl", {
        get: function () {
            return this.get('laboratoryAssay');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormGroup.prototype, "growthStageFormControl", {
        get: function () {
            return this.get('growthStage');
        },
        enumerable: true,
        configurable: true
    });
    SamplingReportFormGroup.SamplingReportFormGroupValidator = function (formGroup) {
        var plantingDateRangeControl = formGroup.plantingDateRangeFormControl;
        var samplingDateRangeControl = formGroup.samplingDateRangeFormControl;
        var plantingDateRange = plantingDateRangeControl.value;
        var samplingDateRange = samplingDateRangeControl.value;
        if ((plantingDateRange && plantingDateRange.length > 1) || (samplingDateRange && samplingDateRange.length > 1)) {
            return null;
        }
        return {
            plantingDateRangeInvalid: true,
            samplingDateRangeInvalid: true
        };
        ;
    };
    return SamplingReportFormGroup;
}(FormGroup));
export { SamplingReportFormGroup };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/reporting/sampling-report-form/sampling-report-form-group.ts.pre-build-optimizer.js